import {
    PAGE_CONTENT_LOADED,
    LOAD_MORE_ARTICLES_REQUEST,
    LOAD_MORE_ARTICLES_SUCCESSFUL,
    LOAD_MORE_ARTICLES_ERROR
} from '../actions'

const initialState = {
    landing_page_uid: undefined,
    articles: [],
    loadingMore: false,
    page: 0,
    total_pages: 0,
    error: undefined,
    tags: undefined,
    gender: undefined
}

const content = (state = initialState, action) => {
    switch (action.type) {
        case PAGE_CONTENT_LOADED:
            if( action.payload.content.type === "today_landing_page" ||
                action.payload.content.type === "landing_page" ||
                action.payload.content.type === "lookbooks_landing_page")
            {
                if(state.articles && state.articles.length > 0 &&
                    state.landing_page_uid === action.payload.content.landing_page_uid &&
                    state.tags === action.payload.content.tags &&
                    state.gender === action.payload.content.gender ) {
                    return state;
                }

                return {
                    ...state,
                    landing_page_uid: action.payload.content.landing_page_uid,
                    loadingMore: false,
                    error: null,
                    page: action.payload.content.page,
                    total_pages: action.payload.content.total_pages,
                    tags: action.payload.content.tags,
                    gender: action.payload.content.gender,
                    articles: action.payload.content.results || [],
                }
            // TODO: This breaks the back functionality
            // I think we should key the next page data
            } else if (action.payload.content.type === "article") {
                return initialState;
            } else {
                return state;
            }

        case LOAD_MORE_ARTICLES_REQUEST:
            return {
                ...state,
                error: null,
                loadingMore: true
            }
        case LOAD_MORE_ARTICLES_ERROR:
            return {
                ...state,
                loadingMore: false,
                error: {message: "Error loading articles"},
            }
        case LOAD_MORE_ARTICLES_SUCCESSFUL:
            return {
                ...state,
                loadingMore: false,
                error: null,
                page: action.payload.content.page,
                total_pages: action.payload.content.total_pages,
                tags: action.payload.content.tags,
                gender: action.payload.content.gender,
                articles: action.payload.content.results && [
                    ...state.articles,
                    ...action.payload.content.results
                ]
            }
        default:
            return state
    }
}

export default content



// WEBPACK FOOTER //
// ./src/reducers/articles.js